<template>
<AvertissementComponents/>
</template>
<script setup lang="ts">
import AvertissementComponents from '@/components/AvertissementComponents.vue';

</script>